define('plugin/invoice/view/InvoiceNotificationLayout',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Invoice notification layout
     *
     * @class InvoiceNotificationLayout
     */
    return LayoutView.extend({

        template: '#invoice_notification_layout',
        ui: {
            'closeBtn': '#sb_invoice_notification_close',
            'openBtn': '#sb_invoice_notification_open',
            'texts': '.invoice-notification .invoice-notification--content-body',
        },
        events: {
            'click @ui.closeBtn': 'onClose',
            'click @ui.openBtn': 'onOpen'
        },
        _collection: null,

        initialize: function () {
            this._collection = this.getOption('collection');
            var instance = this;
            this.listenTo(this._collection, 'sync', function () {
                instance.render();
            });
        },

        onClose: function () {
            $(this.el).addClass('closed');
            $(this.ui.texts).addClass('invoice-notification--content-body--hidden');
        },

        onOpen: function () {
            var _this = this;
            $(this.el).removeClass('closed');
            setTimeout(function (){
                $(_this.ui.texts).removeClass('invoice-notification--content-body--hidden');
            }, 250)
        },

        serializeData: function () {
            var item = this._collection.first();
            return {
                'item': item
            };
        }

    });

});
